module.exports = __webpack_public_path__ + "static/media/image (17).53fd4ccb.jpg";